export class WsBackupStatus{
    public Id!: string
    public BackupLocation!: string;
    public Created!: Date;
}